//document.addEventListener("DOMContentLoaded", function () {
    let navAll = document.querySelectorAll(".nav-level__item"),
        infosBlockAll = document.querySelectorAll(".infos-block");
    window.choiceYourCategory = function (e) {
        e = e || window.event;
        let target = e.target,
            sectionName = target.getAttribute("data-id");
        for (let i = 0; i < navAll.length; i++) navAll[i].classList.remove("active");
        for (let i = 0; i < infosBlockAll.length; i++) infosBlockAll[i].classList.remove("show-block");
        target.classList.add("active"), document.querySelector("#" + sectionName).classList.add("show-block");
    };
    const sizes = {
            tabBras: [
                { bustCircumference: "63-67", cup: "A", sizeFR: "80", chestSize: "77-79" },
                { bustCircumference: "63-67", cup: "B", sizeFR: "80", chestSize: "79-81" },
                { bustCircumference: "63-67", cup: "C", sizeFR: "80", chestSize: "81-83" },
                { bustCircumference: "63-67", cup: "D", sizeFR: "80", chestSize: "83-85" },
                { bustCircumference: "63-67", cup: "E", sizeFR: "80", chestSize: "84-87" },
                { bustCircumference: "63-67", cup: "F", sizeFR: "80", chestSize: "87-89" },
                { bustCircumference: "68-72", cup: "A", sizeFR: "85", chestSize: "82-84" },
                { bustCircumference: "68-72", cup: "B", sizeFR: "85", chestSize: "84-86" },
                { bustCircumference: "68-72", cup: "C", sizeFR: "85", chestSize: "86-88" },
                { bustCircumference: "68-72", cup: "D", sizeFR: "85", chestSize: "88-90" },
                { bustCircumference: "68-72", cup: "E", sizeFR: "85", chestSize: "90-92" },
                { bustCircumference: "68-72", cup: "F", sizeFR: "85", chestSize: "92-94" },
                { bustCircumference: "73-77", cup: "A", sizeFR: "90", chestSize: "87-89" },
                { bustCircumference: "73-77", cup: "B", sizeFR: "90", chestSize: "89-91" },
                { bustCircumference: "73-77", cup: "C", sizeFR: "90", chestSize: "91-93" },
                { bustCircumference: "73-77", cup: "D", sizeFR: "90", chestSize: "93-95" },
                { bustCircumference: "73-77", cup: "E", sizeFR: "90", chestSize: "95-97" },
                { bustCircumference: "73-77", cup: "F", sizeFR: "90", chestSize: "97-99" },
                { bustCircumference: "78-82", cup: "A", sizeFR: "95", chestSize: "92-94" },
                { bustCircumference: "78-82", cup: "B", sizeFR: "95", chestSize: "94-96" },
                { bustCircumference: "78-82", cup: "C", sizeFR: "95", chestSize: "96-98" },
                { bustCircumference: "78-82", cup: "D", sizeFR: "95", chestSize: "98-100" },
                { bustCircumference: "78-82", cup: "E", sizeFR: "95", chestSize: "100-102" },
                { bustCircumference: "78-82", cup: "F", sizeFR: "95", chestSize: "102-104" },
                { bustCircumference: "83-87", cup: "A", sizeFR: "100", chestSize: "97-99" },
                { bustCircumference: "83-87", cup: "B", sizeFR: "100", chestSize: "99-101" },
                { bustCircumference: "83-87", cup: "C", sizeFR: "100", chestSize: "101-103" },
                { bustCircumference: "83-87", cup: "D", sizeFR: "100", chestSize: "103-105" },
                { bustCircumference: "83-87", cup: "E", sizeFR: "100", chestSize: "105-107" },
                { bustCircumference: "83-87", cup: "F", sizeFR: "100", chestSize: "107-109" },
                { bustCircumference: "88-92", cup: "A", sizeFR: "105", chestSize: "102-104" },
                { bustCircumference: "88-92", cup: "B", sizeFR: "105", chestSize: "104-106" },
                { bustCircumference: "88-92", cup: "C", sizeFR: "105", chestSize: "106-108" },
                { bustCircumference: "88-92", cup: "D", sizeFR: "105", chestSize: "108-110" },
                { bustCircumference: "88-92", cup: "E", sizeFR: "105", chestSize: "110-112" },
                { bustCircumference: "88-92", cup: "F", sizeFR: "105", chestSize: "112-114" },
                { bustCircumference: "93-97", cup: "A", sizeFR: "110", chestSize: "107-109" },
                { bustCircumference: "93-97", cup: "B", sizeFR: "110", chestSize: "109-111" },
                { bustCircumference: "93-97", cup: "C", sizeFR: "110", chestSize: "111-113" },
                { bustCircumference: "93-97", cup: "D", sizeFR: "110", chestSize: "113-115" },
                { bustCircumference: "93-97", cup: "E", sizeFR: "110", chestSize: "115-117" },
                { bustCircumference: "93-97", cup: "F", sizeFR: "110", chestSize: "117-119" },
                { bustCircumference: "98-102", cup: "A", sizeFR: "115", chestSize: "112-114" },
                { bustCircumference: "98-102", cup: "B", sizeFR: "115", chestSize: "114-116" },
                { bustCircumference: "98-102", cup: "C", sizeFR: "115", chestSize: "116-118" },
                { bustCircumference: "98-102", cup: "D", sizeFR: "115", chestSize: "118-120" },
                { bustCircumference: "98-102", cup: "E", sizeFR: "115", chestSize: "120-122" },
                { bustCircumference: "98-102", cup: "F", sizeFR: "115", chestSize: "122-124" },
                { bustCircumference: "103-107", cup: "A", sizeFR: "120", chestSize: "117-119" },
                { bustCircumference: "103-107", cup: "B", sizeFR: "120", chestSize: "119-121" },
                { bustCircumference: "103-107", cup: "C", sizeFR: "120", chestSize: "121-123" },
                { bustCircumference: "103-107", cup: "D", sizeFR: "120", chestSize: "123-125" },
                { bustCircumference: "103-107", cup: "E", sizeFR: "120", chestSize: "125-127" },
                { bustCircumference: "103-107", cup: "F", sizeFR: "120", chestSize: "127-129" },
            ],
            tabKnickers: [
                { basinCircumference: "86-90", sizeUK: "(XS)", sizeFR: "38", waistSize: "62-66" },
                { basinCircumference: "91-95", sizeUK: "(S)", sizeFR: "40", waistSize: "67-71" },
                { basinCircumference: "96-100", sizeUK: "(M)", sizeFR: "42", waistSize: "72-76" },
                { basinCircumference: "101-105", sizeUK: "(L)", sizeFR: "44", waistSize: "77-81" },
                { basinCircumference: "106-110", sizeUK: "(XL)", sizeFR: "46", waistSize: "82-86" },
                { basinCircumference: "111-115", sizeUK: "(2XL)", sizeFR: "48", waistSize: "87-91" },
                { basinCircumference: "116-120", sizeUK: "(3XL)", sizeFR: "50", waistSize: "92-96" },
                { basinCircumference: "121-125", sizeUK: "(4XL)", sizeFR: "52", waistSize: "97-101" },
                { basinCircumference: "126-130", sizeUK: "(5XL)", sizeFR: "54", waistSize: "102-106" },
                { basinCircumference: "131-135", sizeUK: "(6XL)", sizeFR: "56", waistSize: "107-111" },
            ],
            tabTights: [
                { weightTights: "35-40", sizeFR: "1", sizeTights: "1,45-1,50" },
                { weightTights: "35-40", sizeFR: "1", sizeTights: "1,50-1,55" },
                { weightTights: "35-40", sizeFR: "1", sizeTights: "1,55-1,60" },
                { weightTights: "35-40", sizeFR: "1", sizeTights: "1,60-1,65" },
                { weightTights: "40-45", sizeFR: "1", sizeTights: "1,45-1,50" },
                { weightTights: "40-45", sizeFR: "1", sizeTights: "1,50-1,55" },
                { weightTights: "40-45", sizeFR: "1", sizeTights: "1,55-1,60" },
                { weightTights: "40-45", sizeFR: "1", sizeTights: "1,60-1,65" },
                { weightTights: "40-45", sizeFR: "2", sizeTights: "1,65-1,70" },
                { weightTights: "45-50", sizeFR: "1", sizeTights: "1,45-1,50" },
                { weightTights: "45-50", sizeFR: "1", sizeTights: "1,50-1,55" },
                { weightTights: "45-50", sizeFR: "1", sizeTights: "1,55-1,60" },
                { weightTights: "45-50", sizeFR: "1", sizeTights: "1,60-1,65" },
                { weightTights: "45-50", sizeFR: "2", sizeTights: "1,65-1,70" },
                { weightTights: "45-50", sizeFR: "3", sizeTights: "1,70-1,75" },
                { weightTights: "45-50", sizeFR: "3", sizeTights: "1,75-1,80" },
                { weightTights: "50-55", sizeFR: "1", sizeTights: "1,45-1,50" },
                { weightTights: "50-55", sizeFR: "1", sizeTights: "1,50-1,55" },
                { weightTights: "50-55", sizeFR: "2", sizeTights: "1,55-1,60" },
                { weightTights: "50-55", sizeFR: "2", sizeTights: "1,60-1,65" },
                { weightTights: "50-55", sizeFR: "2", sizeTights: "1,65-1,70" },
                { weightTights: "50-55", sizeFR: "3", sizeTights: "1,70-1,75" },
                { weightTights: "50-55", sizeFR: "3", sizeTights: "1,75-1,80" },
                { weightTights: "55-60", sizeFR: "2", sizeTights: "1,45-1,50" },
                { weightTights: "55-60", sizeFR: "2", sizeTights: "1,50-1,55" },
                { weightTights: "55-60", sizeFR: "2", sizeTights: "1,55-1,60" },
                { weightTights: "55-60", sizeFR: "2", sizeTights: "1,60-1,65" },
                { weightTights: "55-60", sizeFR: "2", sizeTights: "1,65-1,70" },
                { weightTights: "55-60", sizeFR: "3", sizeTights: "1,70-1,75" },
                { weightTights: "55-60", sizeFR: "3", sizeTights: "1,75-1,80" },
                { weightTights: "60-65", sizeFR: "2", sizeTights: "1,45-1,50" },
                { weightTights: "60-65", sizeFR: "2", sizeTights: "1,50-1,55" },
                { weightTights: "60-65", sizeFR: "2", sizeTights: "1,55-1,60" },
                { weightTights: "60-65", sizeFR: "2", sizeTights: "1,60-1,65" },
                { weightTights: "60-65", sizeFR: "3", sizeTights: "1,65-1,70" },
                { weightTights: "60-65", sizeFR: "3", sizeTights: "1,70-1,75" },
                { weightTights: "60-65", sizeFR: "4", sizeTights: "1,75-1,80" },
                { weightTights: "60-65", sizeFR: "4", sizeTights: "1,80-1,85" },
                { weightTights: "65-70", sizeFR: "2", sizeTights: "1,45-1,50" },
                { weightTights: "65-70", sizeFR: "2", sizeTights: "1,50-1,55" },
                { weightTights: "65-70", sizeFR: "3", sizeTights: "1,55-1,60" },
                { weightTights: "65-70", sizeFR: "3", sizeTights: "1,60-1,65" },
                { weightTights: "65-70", sizeFR: "3", sizeTights: "1,65-1,70" },
                { weightTights: "65-70", sizeFR: "3", sizeTights: "1,70-1,75" },
                { weightTights: "65-70", sizeFR: "4", sizeTights: "1,75-1,80" },
                { weightTights: "65-70", sizeFR: "4", sizeTights: "1,80-1,85" },
                { weightTights: "70-75", sizeFR: "3", sizeTights: "1,50-1,55" },
                { weightTights: "70-75", sizeFR: "3", sizeTights: "1,55-1,60" },
                { weightTights: "70-75", sizeFR: "3", sizeTights: "1,60-1,65" },
                { weightTights: "70-75", sizeFR: "3", sizeTights: "1,65-1,70" },
                { weightTights: "70-75", sizeFR: "4", sizeTights: "1,70-1,75" },
                { weightTights: "70-75", sizeFR: "4", sizeTights: "1,75-1,80" },
                { weightTights: "70-75", sizeFR: "5", sizeTights: "1,80-1,85" },
                { weightTights: "75-80", sizeFR: "3", sizeTights: "1,50-1,55" },
                { weightTights: "75-80", sizeFR: "4", sizeTights: "1,55-1,60" },
                { weightTights: "75-80", sizeFR: "4", sizeTights: "1,60-1,65" },
                { weightTights: "75-80", sizeFR: "4", sizeTights: "1,65-1,70" },
                { weightTights: "75-80", sizeFR: "4", sizeTights: "1,70-1,75" },
                { weightTights: "75-80", sizeFR: "4", sizeTights: "1,75-1,80" },
                { weightTights: "75-80", sizeFR: "5", sizeTights: "1,80-1,85" },
                { weightTights: "80-85", sizeFR: "4", sizeTights: "1,55-1,60" },
                { weightTights: "80-85", sizeFR: "4", sizeTights: "1,60-1,65" },
                { weightTights: "80-85", sizeFR: "4", sizeTights: "1,65-1,70" },
                { weightTights: "80-85", sizeFR: "5", sizeTights: "1,70-1,75" },
                { weightTights: "80-85", sizeFR: "5", sizeTights: "1,75-1,80" },
                { weightTights: "80-85", sizeFR: "5", sizeTights: "1,80-1,85" },
                { weightTights: "85-90", sizeFR: "4", sizeTights: "1,55-1,60" },
                { weightTights: "85-90", sizeFR: "4", sizeTights: "1,60-1,65" },
                { weightTights: "85-90", sizeFR: "4", sizeTights: "1,65-1,70" },
                { weightTights: "85-90", sizeFR: "5", sizeTights: "1,70-1,75" },
                { weightTights: "85-90", sizeFR: "5", sizeTights: "1,75-1,80" },
                { weightTights: "85-90", sizeFR: "5", sizeTights: "1,80-1,85" },
                { weightTights: "90-95", sizeFR: "5", sizeTights: "1,60-1,65" },
                { weightTights: "90-95", sizeFR: "5", sizeTights: "1,65-1,70" },
                { weightTights: "90-95", sizeFR: "5", sizeTights: "1,70-1,75" },
                { weightTights: "90-95", sizeFR: "5", sizeTights: "1,75-1,80" },
                { weightTights: "90-95", sizeFR: "5", sizeTights: "1,80-1,85" },
                { weightTights: "95-100", sizeFR: "5", sizeTights: "1,60-1,65" },
                { weightTights: "95-100", sizeFR: "5", sizeTights: "1,65-1,70" },
                { weightTights: "95-100", sizeFR: "5", sizeTights: "1,70-1,75" },
                { weightTights: "95-100", sizeFR: "5", sizeTights: "1,75-1,80" },
                { weightTights: "95-100", sizeFR: "6", sizeTights: "1,80-1,85" },
                { weightTights: "100-105", sizeFR: "5", sizeTights: "1,60-1,65" },
                { weightTights: "100-105", sizeFR: "5", sizeTights: "1,65-1,70" },
                { weightTights: "100-105", sizeFR: "5", sizeTights: "1,70-1,75" },
                { weightTights: "100-105", sizeFR: "6", sizeTights: "1,75-1,80" },
                { weightTights: "100-105", sizeFR: "6", sizeTights: "1,80-1,85" },
                { weightTights: "105-110", sizeFR: "5", sizeTights: "1,60-1,65" },
                { weightTights: "105-110", sizeFR: "6", sizeTights: "1,65-1,70" },
                { weightTights: "105-110", sizeFR: "6", sizeTights: "1,70-1,75" },
                { weightTights: "105-110", sizeFR: "6", sizeTights: "1,75-1,80" },
                { weightTights: "105-110", sizeFR: "6", sizeTights: "1,80-1,85" },
                { weightTights: "110-115", sizeFR: "6", sizeTights: "1,60-1,65" },
                { weightTights: "110-115", sizeFR: "6", sizeTights: "1,65-1,70" },
                { weightTights: "110-115", sizeFR: "6", sizeTights: "1,70-1,75" },
                { weightTights: "110-115", sizeFR: "6", sizeTights: "1,75-1,80" },
                { weightTights: "110-115", sizeFR: "6", sizeTights: "1,80-1,85" },
                { weightTights: "115-120", sizeFR: "6", sizeTights: "1,60-1,65" },
                { weightTights: "115-120", sizeFR: "6", sizeTights: "1,65-1,70" },
                { weightTights: "115-120", sizeFR: "6", sizeTights: "1,70-1,75" },
                { weightTights: "115-120", sizeFR: "6", sizeTights: "1,75-1,80" },
                { weightTights: "115-120", sizeFR: "6", sizeTights: "1,80-1,85" },
            ],
            tabLegging: [
                { weightLegging: "35-40", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "35-40", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "35-40", sizeFR: "1/2", sizeLegging: "1,55-1,60" },
                { weightLegging: "35-40", sizeFR: "1/2", sizeLegging: "1,60-1,65" },
                { weightLegging: "40-45", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "40-45", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "40-45", sizeFR: "1/2", sizeLegging: "1,55-1,60" },
                { weightLegging: "40-45", sizeFR: "1/2", sizeLegging: "1,60-1,65" },
                { weightLegging: "40-45", sizeFR: "1/2", sizeLegging: "1,65-1,70" },
                { weightLegging: "45-50", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "45-50", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "45-50", sizeFR: "1/2", sizeLegging: "1,55-1,60" },
                { weightLegging: "45-50", sizeFR: "1/2", sizeLegging: "1,60-1,65" },
                { weightLegging: "45-50", sizeFR: "1/2", sizeLegging: "1,65-1,70" },
                { weightLegging: "45-50", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "45-50", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "50-55", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "50-55", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "50-55", sizeFR: "1/2", sizeLegging: "1,55-1,60" },
                { weightLegging: "50-55", sizeFR: "1/2", sizeLegging: "1,60-1,65" },
                { weightLegging: "50-55", sizeFR: "1/2", sizeLegging: "1,65-1,70" },
                { weightLegging: "50-55", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "50-55", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "55-60", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "55-60", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "55-60", sizeFR: "1/2", sizeLegging: "1,55-1,60" },
                { weightLegging: "55-60", sizeFR: "1/2", sizeLegging: "1,60-1,65" },
                { weightLegging: "55-60", sizeFR: "1/2", sizeLegging: "1,65-1,70" },
                { weightLegging: "55-60", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "55-60", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "60-65", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "60-65", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "60-65", sizeFR: "1/2", sizeLegging: "1,55-1,60" },
                { weightLegging: "60-65", sizeFR: "1/2", sizeLegging: "1,60-1,65" },
                { weightLegging: "60-65", sizeFR: "3/4", sizeLegging: "1,65-1,70" },
                { weightLegging: "60-65", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "60-65", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "60-65", sizeFR: "3/4", sizeLegging: "1,80-1,85" },
                { weightLegging: "65-70", sizeFR: "1/2", sizeLegging: "1,45-1,50" },
                { weightLegging: "65-70", sizeFR: "1/2", sizeLegging: "1,50-1,55" },
                { weightLegging: "65-70", sizeFR: "3/4", sizeLegging: "1,55-1,60" },
                { weightLegging: "65-70", sizeFR: "3/4", sizeLegging: "1,60-1,65" },
                { weightLegging: "65-70", sizeFR: "3/4", sizeLegging: "1,65-1,70" },
                { weightLegging: "65-70", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "65-70", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "65-70", sizeFR: "3/4", sizeLegging: "1,80-1,85" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,50-1,55" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,55-1,60" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,60-1,65" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,65-1,70" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "70-75", sizeFR: "3/4", sizeLegging: "1,80-1,85" },
                { weightLegging: "75-80", sizeFR: "3/4", sizeLegging: "1,50-1,55" },
                { weightLegging: "75-80", sizeFR: "3/4", sizeLegging: "1,55-1,60" },
                { weightLegging: "75-80", sizeFR: "3/4", sizeLegging: "1,60-1,65" },
                { weightLegging: "75-80", sizeFR: "3/4", sizeLegging: "1,65-1,70" },
                { weightLegging: "75-80", sizeFR: "3/4", sizeLegging: "1,70-1,75" },
                { weightLegging: "75-80", sizeFR: "3/4", sizeLegging: "1,75-1,80" },
                { weightLegging: "80-85", sizeFR: "3/4", sizeLegging: "1,55-1,60" },
                { weightLegging: "80-85", sizeFR: "3/4", sizeLegging: "1,60-1,65" },
                { weightLegging: "80-85", sizeFR: "3/4", sizeLegging: "1,65-1,70" },
                { weightLegging: "85-90", sizeFR: "3/4", sizeLegging: "1,55-1,60" },
                { weightLegging: "85-90", sizeFR: "3/4", sizeLegging: "1,60-1,65" },
                { weightLegging: "85-90", sizeFR: "3/4", sizeLegging: "1,65-1,70" },
            ],
            tabDimUp: [
                { weightDimUp: "45-50", sizeFR: "1", sizeDimUp: "1,45-1,50" },
                { weightDimUp: "45-50", sizeFR: "1", sizeDimUp: "1,50-1,55" },
                { weightDimUp: "45-50", sizeFR: "1", sizeDimUp: "1,55-1,60" },
                { weightDimUp: "45-50", sizeFR: "1", sizeDimUp: "1,60-1,65" },
                { weightDimUp: "45-50", sizeFR: "1", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "50-55", sizeFR: "1", sizeDimUp: "1,45-1,50" },
                { weightDimUp: "50-55", sizeFR: "1", sizeDimUp: "1,50-1,55" },
                { weightDimUp: "50-55", sizeFR: "1", sizeDimUp: "1,55-1,60" },
                { weightDimUp: "50-55", sizeFR: "1", sizeDimUp: "1,60-1,65" },
                { weightDimUp: "50-55", sizeFR: "3", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "50-55", sizeFR: "3", sizeDimUp: "1,70-1,75" },
                { weightDimUp: "50-55", sizeFR: "3", sizeDimUp: "1,75-1,80" },
                { weightDimUp: "55-60", sizeFR: "1", sizeDimUp: "1,45-1,50" },
                { weightDimUp: "55-60", sizeFR: "1", sizeDimUp: "1,50-1,55" },
                { weightDimUp: "55-60", sizeFR: "2", sizeDimUp: "1,55-1,60" },
                { weightDimUp: "55-60", sizeFR: "2", sizeDimUp: "1,60-1,65" },
                { weightDimUp: "55-60", sizeFR: "3", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "55-60", sizeFR: "3", sizeDimUp: "1,70-1,75" },
                { weightDimUp: "55-60", sizeFR: "3", sizeDimUp: "1,75-1,80" },
                { weightDimUp: "55-60", sizeFR: "3", sizeDimUp: "1,80-1,85" },
                { weightDimUp: "60-65", sizeFR: "2", sizeDimUp: "1,45-1,50" },
                { weightDimUp: "60-65", sizeFR: "2", sizeDimUp: "1,50-1,55" },
                { weightDimUp: "60-65", sizeFR: "2", sizeDimUp: "1,55-1,60" },
                { weightDimUp: "60-65", sizeFR: "2", sizeDimUp: "1,60-1,65" },
                { weightDimUp: "60-65", sizeFR: "2", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "60-65", sizeFR: "3", sizeDimUp: "1,70-1,75" },
                { weightDimUp: "60-65", sizeFR: "3", sizeDimUp: "1,75-1,80" },
                { weightDimUp: "60-65", sizeFR: "3", sizeDimUp: "1,80-1,85" },
                { weightDimUp: "65-70", sizeFR: "2", sizeDimUp: "1,50-1,55" },
                { weightDimUp: "65-70", sizeFR: "2", sizeDimUp: "1,55-1,60" },
                { weightDimUp: "65-70", sizeFR: "2", sizeDimUp: "1,60-1,65" },
                { weightDimUp: "65-70", sizeFR: "2", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "65-70", sizeFR: "4", sizeDimUp: "1,70-1,75" },
                { weightDimUp: "65-70", sizeFR: "4", sizeDimUp: "1,75-1,80" },
                { weightDimUp: "65-70", sizeFR: "4", sizeDimUp: "1,80-1,85" },
                { weightDimUp: "70-75", sizeFR: "4", sizeDimUp: "1,60-1,65" },
                { weightDimUp: "70-75", sizeFR: "4", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "70-75", sizeFR: "4", sizeDimUp: "1,70-1,75" },
                { weightDimUp: "70-75", sizeFR: "4", sizeDimUp: "1,75-1,80" },
                { weightDimUp: "70-75", sizeFR: "4", sizeDimUp: "1,80-1,85" },
                { weightDimUp: "75-80", sizeFR: "4", sizeDimUp: "1,65-1,70" },
                { weightDimUp: "75-80", sizeFR: "4", sizeDimUp: "1,70-1,75" },
                { weightDimUp: "75-80", sizeFR: "4", sizeDimUp: "1,75-1,80" },
                { weightDimUp: "75-80", sizeFR: "4", sizeDimUp: "1,80-1,85" },
            ],
        },
        empty = "";
    let resultsSizeBras = document.querySelector("#results-bras"),
        resultsSizeKnickers = document.querySelector("#results-knickers"),
        resultsSizeTights = document.querySelector("#results-tights"),
        resultsSizeLegging = document.querySelector("#results-legging"),
        resultsSizeDimUp = document.querySelector("#results-dimup"),
        resultsSizeBrasSport = document.querySelector("#results-sport"),
        chestSize = document.querySelector("#chest-size"),
        bustCircumference = document.querySelector("#bust-circumference"),
        waistSize = document.querySelector("#waist-size"),
        basinCircumference = document.querySelector("#basin-circumference"),
        chestSizeSport = document.querySelector("#chest-size-sport"),
        bustCircumferenceSport = document.querySelector("#bust-circumference-sport"),
        waistSizeSport = document.querySelector("#waist-size-sport"),
        basinCircumferenceSport = document.querySelector("#basin-circumference-sport"),
        weightTights = document.querySelector("#weight-tights"),
        sizeTights = document.querySelector("#size-tights"),
        weightLegging = document.querySelector("#weight-legging"),
        sizeLegging = document.querySelector("#size-legging"),
        weightDimUp = document.querySelector("#weight-dimup"),
        sizeDimUp = document.querySelector("#size-dimup");
    (window.createOption = function (value, domElem) {
        let tmp = document.createElement("option");
        tmp.setAttribute("value", value), (tmp.text = value), domElem.appendChild(tmp);
    }),
        (window.resetOption = function (domElem) {
            var i,
                L = domElem.options.length - 1;
            for (i = L; i >= 0; i--) domElem.remove(i);
        }),
        (window.results = function (size, cup, domElem) {
            domElem.textContent = size + " " + cup;
        }),
        (window.resetResults = function (domElem) {
            domElem.textContent = "---";
        }),
        chestSize.addEventListener("change", function () {
            let currentChest = this.value,
                currentBust = bustCircumference.value,
                resultCup,
                resultSizeFR;
            for (let i = 0; i < sizes.tabBras.length; i++)
                currentChest !== "undefined" && sizes.tabBras[i].chestSize == currentChest && sizes.tabBras[i].bustCircumference == currentBust
                    ? ((resultCup = sizes.tabBras[i].cup), (resultSizeFR = sizes.tabBras[i].sizeFR))
                    : resetResults(resultsSizeBras);
            resultSizeFR !== "undefined" && resultCup !== "undefined" && results(resultSizeFR, resultCup, resultsSizeBras);
        }),
        bustCircumference.addEventListener("change", function () {
            let currentBust = this.value,
                resultCup,
                resultSizeFR;
            resetOption(chestSize);
            for (let i = 0; i < sizes.tabBras.length; i++)
                if (currentBust !== "undefined" && sizes.tabBras[i].bustCircumference == currentBust) {
                    createOption(sizes.tabBras[i].chestSize, chestSize);
                    let currentChest = chestSize.value;
                    sizes.tabBras[i].chestSize == currentChest && ((resultCup = sizes.tabBras[i].cup), (resultSizeFR = sizes.tabBras[i].sizeFR));
                }
            resultSizeFR !== void 0 && resultCup !== void 0 ? results(resultSizeFR, resultCup, resultsSizeBras) : resetResults(resultsSizeBras);
        }),
        chestSizeSport.addEventListener("change", function () {
            let currentChest = this.value,
                currentBust = bustCircumferenceSport.value,
                resultCup,
                resultSizeFR;
            for (let i = 0; i < sizes.tabBras.length; i++)
                currentChest !== "undefined" && sizes.tabBras[i].chestSize == currentChest && sizes.tabBras[i].bustCircumference == currentBust
                    ? ((resultCup = sizes.tabBras[i].cup), (resultSizeFR = sizes.tabBras[i].sizeFR))
                    : resetResults(resultsSizeBrasSport);
            resultSizeFR !== "undefined" && resultCup !== "undefined" && results(resultSizeFR, resultCup, resultsSizeBrasSport);
        }),
        bustCircumferenceSport.addEventListener("change", function () {
            let currentBust = this.value,
                resultCup,
                resultSizeFR;
            resetOption(chestSizeSport);
            for (let i = 0; i < sizes.tabBras.length; i++)
                if (currentBust !== "undefined" && sizes.tabBras[i].bustCircumference == currentBust) {
                    createOption(sizes.tabBras[i].chestSize, chestSizeSport);
                    let currentChest = chestSizeSport.value;
                    sizes.tabBras[i].chestSize == currentChest && ((resultCup = sizes.tabBras[i].cup), (resultSizeFR = sizes.tabBras[i].sizeFR));
                }
            resultSizeFR !== void 0 && resultCup !== void 0 ? results(resultSizeFR, resultCup, resultsSizeBrasSport) : resetResults(resultsSizeBrasSport);
        }),
        waistSize.addEventListener("change", function () {
            let currentWaist = this.value,
                resultSizeUK,
                resultSizeFR;
            for (let i = 0; i < sizes.tabKnickers.length; i++)
                if (currentWaist !== "undefined" && sizes.tabKnickers[i].waistSize == currentWaist) {
                    let currentBasin = sizes.tabKnickers[i].basinCircumference;
                    (basinCircumference.value = currentBasin), sizes.tabKnickers[i].basinCircumference == currentBasin && ((resultSizeUK = sizes.tabKnickers[i].sizeUK), (resultSizeFR = sizes.tabKnickers[i].sizeFR));
                }
            resultSizeFR !== void 0 && resultSizeUK !== void 0 ? results(resultSizeFR, resultSizeUK, resultsSizeKnickers) : resetResults(resultsSizeKnickers);
        }),
        basinCircumference.addEventListener("change", function () {
            let currentBasin = this.value,
                resultSizeUK,
                resultSizeFR;
            for (let i = 0; i < sizes.tabKnickers.length; i++)
                if (currentBasin !== "undefined" && sizes.tabKnickers[i].basinCircumference == currentBasin) {
                    let currentWaist = sizes.tabKnickers[i].waistSize;
                    (waistSize.value = currentWaist), sizes.tabKnickers[i].waistSize == currentWaist && ((resultSizeUK = sizes.tabKnickers[i].sizeUK), (resultSizeFR = sizes.tabKnickers[i].sizeFR));
                }
            resultSizeFR !== void 0 && resultSizeUK !== void 0 ? results(resultSizeFR, resultSizeUK, resultsSizeKnickers) : resetResults(resultsSizeKnickers);
        }),
        sizeTights.addEventListener("change", function () {
            let currentSize = this.value,
                currentWeight = weightTights.value,
                resultSize,
                resultSizeFR;
            for (let i = 0; i < sizes.tabTights.length; i++)
                currentSize !== "undefined" && sizes.tabTights[i].sizeTights == currentSize && sizes.tabTights[i].weightTights == currentWeight
                    ? ((resultSize = sizes.tabTights[i].sizeTights), (resultSizeFR = sizes.tabTights[i].sizeFR))
                    : resetResults(resultsSizeTights);
            resultSizeFR !== "undefined" && results(resultSizeFR, empty, resultsSizeTights);
        }),
        weightTights.addEventListener("change", function () {
            let currentWeight = this.value,
                resultSize,
                resultSizeFR;
            resetOption(sizeTights);
            for (let i = 0; i < sizes.tabTights.length; i++)
                if (currentWeight !== "undefined" && sizes.tabTights[i].weightTights == currentWeight) {
                    createOption(sizes.tabTights[i].sizeTights, sizeTights);
                    let currentSizeTights = sizeTights.value;
                    sizes.tabTights[i].sizeTights == currentSizeTights && ((resultSize = sizes.tabTights[i].sizeTights), (resultSizeFR = sizes.tabTights[i].sizeFR));
                }
            resultSizeFR !== void 0 ? results(resultSizeFR, empty, resultsSizeTights) : resetResults(resultsSizeTights);
        }),
        sizeLegging.addEventListener("change", function () {
            let currentSize = this.value,
                currentWeight = weightLegging.value,
                resultSize,
                resultSizeFR;
            for (let i = 0; i < sizes.tabLegging.length; i++)
                currentSize !== "undefined" && sizes.tabLegging[i].sizeLegging == currentSize && sizes.tabLegging[i].weightLegging == currentWeight
                    ? ((resultSize = sizes.tabLegging[i].sizeLegging), (resultSizeFR = sizes.tabLegging[i].sizeFR))
                    : resetResults(resultsSizeLegging);
            resultSizeFR !== "undefined" && results(resultSizeFR, empty, resultsSizeLegging);
        }),
        weightLegging.addEventListener("change", function () {
            let currentWeight = this.value,
                resultSize,
                resultSizeFR;
            resetOption(sizeLegging);
            for (let i = 0; i < sizes.tabLegging.length; i++)
                if (currentWeight !== "undefined" && sizes.tabLegging[i].weightLegging == currentWeight) {
                    createOption(sizes.tabLegging[i].sizeLegging, sizeLegging);
                    let currentSizeLegging = sizeLegging.value;
                    sizes.tabLegging[i].sizeLegging == currentSizeLegging && ((resultSize = sizes.tabLegging[i].sizeLegging), (resultSizeFR = sizes.tabLegging[i].sizeFR));
                }
            resultSizeFR !== void 0 ? results(resultSizeFR, empty, resultsSizeLegging) : resetResults(resultsSizeLegging);
        }),
        sizeDimUp.addEventListener("change", function () {
            let currentSize = this.value,
                currentWeight = weightDimUp.value,
                resultSize,
                resultSizeFR;
            for (let i = 0; i < sizes.tabDimUp.length; i++)
                currentSize !== "undefined" && sizes.tabDimUp[i].sizeDimUp == currentSize && sizes.tabDimUp[i].weightDimUp == currentWeight
                    ? ((resultSize = sizes.tabDimUp[i].sizeDimUp), (resultSizeFR = sizes.tabDimUp[i].sizeFR))
                    : resetResults(resultsSizeDimUp);
            resultSizeFR !== "undefined" && results(resultSizeFR, empty, resultsSizeDimUp);
        }),
        weightDimUp.addEventListener("change", function () {
            let currentWeight = this.value,
                resultSize,
                resultSizeFR;
            resetOption(sizeDimUp);
            for (let i = 0; i < sizes.tabDimUp.length; i++)
                if (currentWeight !== "undefined" && sizes.tabDimUp[i].weightDimUp == currentWeight) {
                    createOption(sizes.tabDimUp[i].sizeDimUp, sizeDimUp);
                    let currentSizeDimUp = sizeDimUp.value;
                    sizes.tabDimUp[i].sizeDimUp == currentSizeDimUp && ((resultSize = sizes.tabDimUp[i].sizeDimUp), (resultSizeFR = sizes.tabDimUp[i].sizeFR));
                }
            resultSizeFR !== void 0 ? results(resultSizeFR, empty, resultsSizeDimUp) : resetResults(resultsSizeDimUp);
        });
    let slideUp = (target, duration = 500) => {
            (target.style.transitionProperty = "height, margin, padding"),
                (target.style.transitionDuration = duration + "ms"),
                (target.style.boxSizing = "border-box"),
                (target.style.height = target.offsetHeight + "px"),
                target.offsetHeight,
                (target.style.overflow = "hidden"),
                (target.style.height = 0),
                (target.style.paddingTop = 0),
                (target.style.paddingBottom = 0),
                (target.style.marginTop = 0),
                (target.style.marginBottom = 0),
                window.setTimeout(() => {
                    (target.style.display = "none"),
                        target.style.removeProperty("height"),
                        target.style.removeProperty("padding-top"),
                        target.style.removeProperty("padding-bottom"),
                        target.style.removeProperty("margin-top"),
                        target.style.removeProperty("margin-bottom"),
                        target.style.removeProperty("overflow"),
                        target.style.removeProperty("transition-duration"),
                        target.style.removeProperty("transition-property");
                }, duration);
        },
        slideDown = (target, duration = 500) => {
            target.style.removeProperty("display");
            let display = window.getComputedStyle(target).display;
            display === "none" && (display = "block"), (target.style.display = display);
            let height = target.offsetHeight;
            (target.style.overflow = "hidden"),
                (target.style.height = 0),
                (target.style.paddingTop = 0),
                (target.style.paddingBottom = 0),
                (target.style.marginTop = 0),
                (target.style.marginBottom = 0),
                target.offsetHeight,
                (target.style.boxSizing = "border-box"),
                (target.style.transitionProperty = "height, margin, padding"),
                (target.style.transitionDuration = duration + "ms"),
                (target.style.height = height + "px"),
                target.style.removeProperty("padding-top"),
                target.style.removeProperty("padding-bottom"),
                target.style.removeProperty("margin-top"),
                target.style.removeProperty("margin-bottom"),
                window.setTimeout(() => {
                    target.style.removeProperty("height"), target.style.removeProperty("overflow"), target.style.removeProperty("transition-duration"), target.style.removeProperty("transition-property");
                }, duration);
        },
        slideToggle = (target, duration = 500) => (target.parentNode.querySelector(".chevron-right").classList.toggle("rotate"), window.getComputedStyle(target).display === "none" ? slideDown(target, duration) : slideUp(target, duration)),
        speedAnimation = 400,
        slideBtnClick = (id, sl, targetId) => document.getElementById(id).addEventListener("click", () => sl(targetId, speedAnimation));
        slideBtnClick("slideBras", slideToggle, showTabBras),
        slideBtnClick("slideKnickers", slideToggle, showTabKnickers),
        slideBtnClick("slideTights", slideToggle, showTabTights),
        slideBtnClick("slideSocks", slideToggle, showTabSocks),
        slideBtnClick("slideSwimsuit", slideToggle, showTabSwimsuit),
        slideBtnClick("slidePyjamas", slideToggle, showTabPyjamas),
        slideBtnClick("slideBras", slideToggle, showTabBrasSport),
        ReadMore.init();
//});
//# sourceMappingURL=/cdn/shop/files/script-size-guide-women.js.map
